import { Link } from "gatsby"
import * as React from "react"

const Footer: React.FC = () => {
    return(
      <footer className="bg-primary text-secondary py-10 flex justify-between items-center px-4 relative z-50">
          <div className="flex-none flex-col">
            <div className="">
              <Link to="/about-us" className="px-2">About Us</Link>
            </div>
            <div className="">
              <Link to="/terms-conditions" className="px-2">Term & Conditions</Link>
            </div>
            <div className="">
              <Link to="/privacy-policy" className="px-2">Privacy Policy</Link>
            </div>
            <div className="">
              <Link to="/contact-us" className="px-2">Contact us</Link>
            </div>
            <div className="">
              <Link to="/faq" className="px-2">FAQ</Link>
            </div>
          </div>

          <div className="flex flex-col px-4">
            <div className="">
              <h3>Copyright 2024</h3>
              <p className="text-white text-xs open-sans-normal">Version: {process.env.GATSBY_BUILD_TIME}</p>
            </div>
          </div>
      </footer>
    )
}

export default Footer

